<template>
    <div class="about">
        <div class="coverBgc">
            <img src="../../assets/about/bgc.png" alt="">
            <div class="titleText">
                <div class="title">
                    <div>培养学习型民族精神</div>
                    <div>铸造创新型中华文化</div>
                </div>
                <div class="explain">
                    于教育大数据的思维，中潮教育以创建企业书院为形式，以提升职业能力为核心，以推动职业人才培养为目标，低成本地帮助企业建设线上与线下相结合、学历与非学历相结合、知识与技能相结合的“直教直学”学习系统。
                </div>
            </div>
        </div>
        <div class="content">
            <div class="zh_introduction">
                <div class="zh_title">中潮教育简介</div>
                <div class="zh_introduction_text">
                    <div class="info">
                        武汉市中潮互联网教育有限公司，成立于2015年6月，是一家基于教育大数据思维和产教融合理念，充分利用移动互联网技术手段，通过教育内容与服务的创新，为各类企业、事业单位建立终身学习的教育生态系统；
                        为各类职业人士提供专业、职业、行业知识资源；为教育培训机构提供实现教育价值的渠道；为广大师资提供传授知识、传播思想、传承文化提供舞台的互联网教育企业。 
                    </div>
                    <div class="info" style="margin:8px 0"> 
                        公司秉承“服务为先、内容为王、创新为本”的理念，遵循职业人才成长、成才、成功的规律，通过“明商道”、“明职道”、“明师道”等平台入口，实现专业、职业、行业知识相融通；
                        线上线下教学相融合；学历与非学历教育相结合的基于教育大数据的开放共享型教育模式。</div>
                    <div class="info">
                        公司是国家高新技术企业、双软企业、信息安全三级等保企业、AAA信用企业，具有ISO9001质量管理体系认证、ISO14001环境管理体系认证、ISO45001健康管理体系认证和CMA和CNAS软件测试认证，
                        拥有数十项软件著作权。公司旗下“融E学”平台是上海市、广东省、广州市、深圳市、武汉市等省市人社部门指定的企业职业能力在线提升平台。
                    </div>
                </div>
            </div>
            <div class="bossIntroduce">
                <div class="bossTitle">领导介绍</div>
                <div class="bossInfo">
                    <div class="bossInfoImg"><img src="../../assets/about/boss.png" alt=""></div>
                    <div class="bossInfoText">
                        <div class="bossCreated"><div class="bossName">汪军民</div><div class="identity">中潮互联网教育有限公司创始人兼董事长</div></div>
                        <div class="bossContent">长江互联网教育研究院理事长，“融e学”网、“言职”APP创始人，中南财经政法大学教授、博士生导师，EMCA、MCA资本教育体系创始人、创业逻辑体系创始人。</div>
                    </div>
                </div>
                <div class="bossHonor">
                    精通会计、法律、经济学及企业管理，毕业于武汉理工大学，拥有中国人民大学经济学硕士学位、武汉大学法学博士学位、重庆大学管理学博士学位，中南财经政法大学应用经济学博士后，
                    长江商学院EMBA。具有高级会计师、高级经济师、注册会计师、资产评估师、企业法律顾问等资格。曾任上海复星创业投资管理有限公司投资总经理、金元证券股份有限公司投资银行总部执行董事、
                    中信海洋直升机股份有限公司副总会计师兼财务部经理等职务。兼任多家上市公司独立董事。
                </div>
                <div class="bossInfo">
                    <div class="bossInfoImg"><img src="../../assets/about/boosQiu.png" alt=""></div>
                    <div class="bossInfoText2">
                        <div class="bossCreated2"><div class="bossName2">邱海平</div><div class="identity2">长江互联网教育研究院院长</div></div>
                        <div class="bossContent2">经济学博士、中国人民大学经济学教授、博士生导师。教育部高等学校经济学类专业教学指导委员会秘书长，《教学与研究》杂志主编，中国《资本论》研究会副秘书长，全国综合大学《资本论》研究会秘书长，中国人民大学资本论研究中心主任。</div>
                    </div>
                </div>
            </div>
            <div class="zh_strategy">
                <div class="zh_title">公司战略</div>
                <div class="zh_introduction_text">以职业人才培养为重点，以服务产业发展为目标，建设世界一流的基于教育大数据的现代教育企业</div>
                <div class="list">
                    <div class="listItem" v-for="(item,index) in list" :key="index">
                        <div class="listItem_title">{{item.title}}</div>
                        <div class="listItem_text">{{item.text}}</div>
                    </div>
                </div>
            </div>  
            <div class="idea">
                <img src="../../assets/about/idea.png" alt="">
                <div class="ideaContent">
                    <div class="ideaTitle">教育理念</div>
                    <div class="ideaText">大学之道、在明明德，在亲民，在止于至善</div>
                </div>
            </div>
            <div class="location">
                <div class="locationText">逻辑定位</div>
                <div class="locationImg"><img src="../../assets/about/location.png" alt=""></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list:[
                {title:'服务 “三型” 人才培养',text:'创新型、复合型、应用型'},
                {title:'探索 “三融” 模式',text:'产教融合、线上线下融合，专业、职业、行业融合'},
                {title:'成为 “三性” 产业机构',text:'平台性、科技性、研究性'},
                {title:'打造 “三强” 核心竞争力',text:'强大的师资资源整合能力、强大的资源客户开拓能力、强大的教育内容研究与创新能力'},
            ] 
        };
    },
    created() {

    },
    methods: {

    }
};
</script>

<style scoped lang="scss">
.about{
    .coverBgc{
        height: 320px;
        position: relative;
        .titleText{
            width: 52%;
            position: absolute;
            top: 25px;
            left: 63px;
            color: #fff;
        }
        .title{
            font-size: 42px;
            font-weight: 500;
            padding: 10px 0;
            border-bottom:  1px solid #fff;
        }
        .explain{
            font-weight: 400;
            font-size: 16px;
            margin-top: 20px;
        }
    }
    .content{
        .zh_introduction{
            padding:29px 24px 21px 24px;
        } 
        .bossIntroduce{
            background-color: #0E50B2;
            padding: 25px 24px 46px 24px;
            .bossTitle{
                color: #fff;
                text-align: center;
                font-size: 36px;
                font-weight: 500;
            }
            .bossInfo{
                margin-top: 35px;
                margin-bottom: 38px;
                display: flex;
                color: #fff;
                .bossInfoImg{
                    width: 181px;
                    height: 214px;
                }
                .bossInfoText{
                    min-width:0;
                    flex:1;
                    padding-left: 10px;
                    box-sizing: border-box;
                    .bossCreated{
                        .bossName{
                            font-size: 30px;
                            margin-left: 47px;
                        }
                        .identity{
                            font-size: 21px;
                            margin: 0 0 20px 49px;
                        }
                    }
                    .bossContent{
                        text-indent: 2em;
                        font-size: 21px;
                        font-weight: 500;
                    }  
                }
                .bossInfoText2{
                    min-width:0;
                    flex:1;
                    padding-left: 10px;
                    box-sizing: border-box;
                    .bossCreated2{
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        .bossName2{
                            flex: 2;
                            font-size: 30px;
                            margin-left: 47px;   
                        }
                        .identity2{
                            flex: 7;
                            font-size: 21px;
                            margin-left: 10px;
                        }
                    }
                    .bossContent2{
                        text-indent: 2em;
                        font-size: 21px;
                        font-weight: 500;
                    }  
                }
            }
            .bossHonor{
                margin-top: 29px;
                margin-bottom: 38px;
                font-size: 21px;
                color: #fff;
            }
        }
        .zh_strategy{
            padding: 44px 24px 28px 24px;
            .zh_introduction_text{
                margin-bottom: 20px;
                .info{
                    text-indent: 2em; 
                }
            }
            .list{
                .listItem{
                    padding:35px 18px 40px 18px;
                    background: #004a9f;
                    color: #ffffff;
                    margin-bottom: 10px;
                    .listItem_title{
                        font-size: 30px;
                        font-weight: 500;
                        margin-bottom: 18px;
                    } 
                    .listItem_text{
                        font-size: 21px;
                    }
                } 
            }
        }
        .idea{
            position: relative;
            height: 147px;
            .ideaContent{
                color: #fff;
                position: absolute;
                left: 0;
                top: 29px;
                width: 100%;
                text-align: center;
                .ideaTitle{
                    font-size: 36px;
                    font-weight: 500;
                }
                .ideaText{
                    font-size: 24px;
                    // margin-top: 19px;
                }
            }
        }
        .location{
            padding: 23px 24px 39px 24px;
            .locationText{
                font-weight: 500;
                font-size: 36px;
                color: #242424;
                text-align: center;
                margin-bottom: 27px;
            }
        }
    }
    .zh_title{
        color: #242424;
        font-size: 36px;
        font-weight: 500;
        text-align: center;
    }
    .zh_introduction_text{
        text-indent: 2em;
        font-size: 21px;
        color: #444444;
        margin-top:20px;
    }
    img{
        width: 100%;
        height: 100%;
    }
    .mt{
        margin-top: 38px !important;
    }
}
</style>
